import React, { FC } from 'react';
import { ImageDescription } from 'components/structures/general';
import { solarEnergy, solarEnergy2x } from 'images/us-energy-solutions';
import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  contentClassName: {
    [theme.breakpoints.up('md')]: {
      marginLeft: -theme.spacing(5),
    },
  },
}));

const SolarEnergy: FC = () => {
  const classes = useStyles();
  return (
    <ImageDescription
      image={{
        image: solarEnergy,
        srcSet: `${solarEnergy} 516w, ${solarEnergy2x} 1032w`,
        imageCenterLg: true,
        disableMaxWidthLg: true,
        disableShadow: true,
      }}
      title="Solar Energy"
      text="Solar technologies continue to evolve, providing commercial owners and organizations nationwide with improved energy efficiency and additional energy choices. Regardless of your solar power needs, US Energy Solutions is your premier choice when it comes to finding a system tailored to your needs. The company helps business owners increase their energy profitability."
      contentClassName={classes.contentClassName}
      gridItems={{ contentLg: 4, contentMd: 4, imageMd: 7, imageLg: 7 }}
      link={{ text: 'Give it a go', href: 'https://usenergysolutions.us/solar-energy' }}
    />
  );
};

export default SolarEnergy;
